@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.drivers

import com.narbase.letsgo.router.EndPoint

object GetAvailableDriversEndpoint : EndPoint<GetAvailableDriversEndpoint.Request, GetAvailableDriversEndpoint.Response>() {
    class Request(
        val latCenter: Double,
        val lngCenter: Double
    )

    class Response(
        val driverLocations: Array<LatLngDto>,
    )
}
class LatLngDto(
    val lat: Double,
    val lng: Double
)